import { observable } from "mobx";
import { WorkExperience, EducationExperience, Language } from "./profile";
import { copyArray } from "../utils/data";

export class ParsedResumeResults {
  @observable jobs: Array<WorkExperience>;
  @observable educations: Array<EducationExperience>;
  @observable languages: Array<Language>;
  @observable existingJobs: number;
  @observable existingEducations: number;
  @observable existingLanguages: number;
  @observable name: string;
  @observable upload: Date;
  @observable resumeId: string;

  constructor(prr: ParsedResumeResults)
  {
    this.jobs = new Array<WorkExperience>();
    if (prr.jobs) {
      copyArray(prr.jobs, this.jobs, (j: WorkExperience) => { return new WorkExperience(j); });
    }
    this.educations = new Array<EducationExperience>();
    if (prr.educations) {
      copyArray(prr.educations, this.educations, (e: EducationExperience) => { return new EducationExperience(e); });
    }
    this.languages = new Array<Language>();
    if (prr.languages) {
      copyArray(prr.languages, this.languages, (l: Language) => { return new Language(l); });
    }
    this.existingJobs = prr.existingJobs;
    this.existingEducations = prr.existingEducations;
    this.existingLanguages = prr.existingLanguages;
    this.name = prr.name;
    if (prr.upload) {
        this.upload = new Date(prr.upload.valueOf());
    }
    this.resumeId = prr.resumeId;
  }
}



// WEBPACK FOOTER //
// ./src/models/parsedResumeResults.ts